export default __webpack_public_path__ + "static/media/landing-middle_converted.ac49d901.jpg";